import type { ThreadMetricsSurfaceState } from '@fruitful/llm-service-shared';
import { AnalyticsUserEvent } from '@fruitful/types';
import { useEffect, useRef } from 'react';

import { track, trackGrowthMarketingEvent } from '../../logger/Logger';

/**
 * Tracks when streamed/restored CMM thread metadata branch or currentStep changes.
 */
export const useTrackThreadMetadata = (
    threadMetadata: ThreadMetricsSurfaceState | null,
): void => {
    const prevBranchRef = useRef<string | null | undefined>(undefined);
    const prevStepRef = useRef<string | null | undefined>(undefined);

    useEffect(() => {
        const branch = threadMetadata?.branch ?? null;
        const step = threadMetadata?.currentStep ?? null;

        if (branch !== prevBranchRef.current) {
            if (branch != null) {
                track(AnalyticsUserEvent.SIGNUP_FUNNEL_CMM_BRANCH_SELECTED, {
                    branch,
                });
                trackGrowthMarketingEvent(
                    AnalyticsUserEvent.SIGNUP_FUNNEL_CMM_BRANCH_SELECTED,
                    { branch },
                );
            }
            prevBranchRef.current = branch;
        }

        if (step !== prevStepRef.current) {
            if (step != null) {
                track(
                    AnalyticsUserEvent.SIGNUP_FUNNEL_CMM_CURRENT_STEP_UPDATED,
                    {
                        currentStep: step,
                    },
                );
            }
            prevStepRef.current = step;
        }
    }, [threadMetadata]);
};
